export default {
  SET_GIFTCARD_OPERATORS (state, payload) {
    state.giftCardOperators = payload;
  },
  SET_GIFTCARD_AMOUNTS (state, payload) {
    state.giftCardAmounts = payload;
  },
};
